import axiosInstance from "../config/axiosApi/axiosApi.jsx";
import APIs from "../Constants/apis.js";

/**
 * Service to handle user profile and settings data fetching
 */
export const userDataService = {
  /**
   * Fetch user profile data
   * @returns {Promise<Object>} Profile data
   */
  async fetchUserProfile() {
    try {
      const response = await axiosInstance.get(APIs.GET_COMPANY_PROFILE);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      throw error;
    }
  },

  /**
   * Fetch user settings data
   * @returns {Promise<Object>} Settings data
   */
  async fetchUserSettings() {
    try {
      const response = await axiosInstance.get(APIs.GET_COMPANY_SETTINGS);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching user settings:", error);
      throw error;
    }
  },

  /**
   * Fetch both profile and settings data
   * @returns {Promise<Object>} Object containing profileData and settingsData
   */
  async fetchUserData() {
    try {
      const [profileResponse, settingsResponse] = await Promise.all([
        this.fetchUserProfile(),
        this.fetchUserSettings()
      ]);

      return {
        profileData: profileResponse,
        settingsData: settingsResponse,
        lastDataRefresh: new Date().toISOString()
      };
    } catch (error) {
      console.error("Error fetching user data:", error);
      throw error;
    }
  }
};

export default userDataService;
